import { render, staticRenderFns } from "./attr-output.vue?vue&type=template&id=0e6a37e6&scoped=true&"
import script from "./attr-output.vue?vue&type=script&lang=ts&"
export * from "./attr-output.vue?vue&type=script&lang=ts&"
import style0 from "./attr-output.vue?vue&type=style&index=0&id=0e6a37e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6a37e6",
  null
  
)

export default component.exports